import React , {useEffect }from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Grid, Button, IconButton, Paper } from '@mui/material';
import Typography from '@mui/material/Typography';
import clsx from 'clsx';
import { useCopy } from 'hooks';
import { getEnvFullUrl } from 'constant';
import { SimpleDialog, ButtonLoading, Icons, PriceLabel , NumberToPersianWords} from 'components';
import detailAccountsServices from '../../../DigitalAccountServices';
import { useStyles } from './style';
import useCustomHook from '../../hooks';
import { getDynamicObjectAction } from 'utility';
import { useCurrencyUnit } from 'hooks';


const appURL = getEnvFullUrl();

const Wallet = (props) => {
  const {
    loading,
    setLoading,
    openDialog,
    setOpenDialog,
    userBillNumber,
    setUserBillNumber,
    loadingCartable,
    setLoadingCartable,
    disabledBtn,
    setDisabledBtn,
    checkConfig, setCheckConfig
  } = useCustomHook();
  
  const currentLoaction = useLocation();
  const actionsList = getDynamicObjectAction([
    'chargeAccountBtn',
    'digitalCardService',
    'chargeImprestAccountBtn',
    'reportAccountBtn',
    'reportImprestAccountBtn',
    'depositIdAccountBtn',
    'depositImprestIdAccountBtn',
    'MoneyTransferAccountBtn',
    'MoneyImprestTransferAccountBtn',
    'FinancialLicensesAccountBtn',
    'FinancialImprestLicensesAccountBtn',
    'FinancialLicensesReciveAccountBtn',
    'FinancialImprestLicensesReciveAccountBtn',
    'withdrawAccountBtn',
    'withdrawImprestAccountBtn',
  ]);
  const classes = useStyles();
  const { data, accDetails, origin, blocks } = props;
  const currencyText = useCurrencyUnit(false)
  const navigate = useNavigate();
  const { copyItem } = useCopy();

  const getBlockedAmount = (walletCode) => {
    const f = blocks.find((v) => v?.wallet === walletCode);
    return f;
  };

  const charge = async (wallet) => {
    const params = {
      redirectUri: `${appURL}Accounts`,
      callUri: 'charged',
      wallet,
    };

    try {
      const res = await detailAccountsServices.charge(params);
      window.open(res.result);
    } catch (error) {}
  };

  const generateCreditInvoicePaymentNumber = async (wallet, currency) => {
    setLoading(true);

    try {
      const res = await detailAccountsServices.generateCreditInvoicePaymentNumber({
        currency,
        wallet,
      });

      setLoading(false);
      setUserBillNumber(res.result.userBillNumber);
      setOpenDialog(true);
    } catch (error) {
      setLoading(false);
    }
  };

  const onCheckIsCartable = async (item) => {
    setLoadingCartable(item?.id);
    setDisabledBtn(true);
    const params = {
      offset: 0,
      size: 10,
      typeCode: 'MULTI_CONFIRMATION_TYPE_SETTLEMENT',
      wallet: item?.wallet,
    };

    try {
      const res = await detailAccountsServices.checkCartable(params);
      if (!String(window.location.pathname).toUpperCase().includes('/ACCOUNTS')) {
        return;
      }
      if (
        res?.data?.result?.length !== 0 &&
        res?.data?.result[0]?.multiConfirmationSrv?.enable &&
        !res?.data?.result[0]?.multiConfirmationSrv?.left
      ) {
        handleWallet(item?.id, 'Cartable', item, res?.data?.result[0]?.multiConfirmationSrv?.id);
      } else {
        handleWallet(item?.id, 'Withdrawal', item);
      }
      setLoadingCartable(0);
      setDisabledBtn(false);
    } catch (error) {
      setLoadingCartable(0);
      setDisabledBtn(false);
    }
  };
  const handleWallet = (id, title, item, cartableId) => {
    switch (title) {
      case 'settlement':
        return navigate(`/Guilds/AutoSettlement/${id}?origin=${origin}`, {
          item,
        });

      case 'MoneyTransfer':
        return navigate(
          `/TransferCreditWallet/${id}${
            String(window.location.pathname).toUpperCase().includes('/IMPREST')
              ? '?sourceMenu=IMPREST'
              : ''
          }`,
          {
            item,
            accDetails,
          },
        );

      case 'Withdrawal':
        return navigate(
          `/WalletCashout/${id}${
            String(window.location.pathname).toUpperCase().includes('/IMPREST')
              ? '?sourceMenu=IMPREST'
              : ''
          }`,
          {
            item,
          },
        );

      case 'Transactions':
        return navigate(
          `/TransactionsWallet/${item.id}${
            String(window.location.pathname).toUpperCase().includes('/IMPREST')
              ? '?sourceMenu=IMPREST'
              : ''
          }`,
        );
      case 'Cartable':
        return navigate(
          `/WalletCartableCashout/${id}?wCode=${
            item?.wallet
          }&gCode=null&typeCode=MULTI_CONFIRMATION_TYPE_SETTLEMENT&cartableId=${
            cartableId || 'null'
          }${
            String(window.location.pathname).toUpperCase().includes('/IMPREST')
              ? '&sourceMenu=IMPREST'
              : ''
          }`,
        );

      case 'DirectDebit':
        return navigate('/DirectDebit');

      case 'IssueCards':
        return navigate({
          pathname: '/IssueCards',
          search: `?name=${item?.walletName}&fullNameOwner=${item?.walletName}&id=${item?.id}&Type=Wallet`,
        });
      case 'GrantPermission':
        return navigate({
          pathname: '/Permission/GrantedWallet',
          search: `?wallet=${id}${
            String(window.location.pathname).toUpperCase().includes('/IMPREST')
              ? '&sourceMenu=IMPREST'
              : ''
          }`,
        });
      case 'GrantPermissionReceived':
        return navigate({
          pathname: '/Permission/ReceivedWallet',
          search: `?wallet=${id}${
            String(window.location.pathname).toUpperCase().includes('/IMPREST')
              ? '&sourceMenu=IMPREST'
              : ''
          }`,
        });

      default:
        return '';
    }
  };

  return (
    <>
      {data.length === 0 ? (
        <Grid container spacing={1} style={{ marginBottom: 8 }}>
          <Grid item xs={12} md={7}>
            <Grid container>
              <Grid item xs={12} className={classes.balanceBox}>
                <Typography className={classes.balanceTitle}>موجودی حساب دیجیتال</Typography>

                <Typography className={classes.balancePrice}>
                  ۰<span className={classes.currencyText}>{currencyText}</span>
                </Typography>

                <Typography className={classes.balancePriceText}>(صفر تومان)</Typography>

                <Typography className={classes.blockedAmount} style={{ marginTop: 8 }}>
                  <span className={classes.blockedAmountIcon}>
                    <Icons icon="blocked" color="#343434" size="18" />
                  </span>
                  مبلغ مسدود شده
                  <b> ۰ {currencyText}</b>
                </Typography>

                <div
                  role="group"
                  aria-label="outlined primary button group"
                  className={classes.buttonWrapper}
                >
                  {(String(currentLoaction?.pathname).toUpperCase().includes('IMPREST')
                    ? actionsList['chargeImprestAccountBtn']
                    : actionsList['chargeAccountBtn']) && (
                    <Button className={classes.button} onClick={() => charge('PODLAND_WALLET')}>
                      شارژ
                    </Button>
                  )}
                  {(String(currentLoaction?.pathname).toUpperCase().includes('IMPREST')
                    ? actionsList['withdrawImprestAccountBtn']
                    : actionsList['withdrawAccountBtn']) && (
                    <Button disabled={true} className={classes.button} onClick={() => {}}>
                      برداشت
                      <br />
                      وجه
                    </Button>
                  )}
                  {(String(currentLoaction?.pathname).toUpperCase().includes('IMPREST')
                    ? actionsList['MoneyImprestTransferAccountBtn']
                    : actionsList['MoneyTransferAccountBtn']) && (
                    <Button disabled={true} className={classes.button} onClick={() => {}}>
                      انتقال
                      <br />
                      وجه
                    </Button>
                  )}
                  {/* {!String(currentLoaction?.pathname).toUpperCase().includes('IMPREST') &&
                    data[0]?.cardRequestSrv && (
                      <Button disabled={true} className={classes.button} onClick={() => {}}>
                        خدمات کارت
                      </Button>
                    )} */}
                  {(String(currentLoaction?.pathname).toUpperCase().includes('IMPREST')
                    ? actionsList['reportImprestAccountBtn']
                    : actionsList['reportAccountBtn']) && (
                    <Button disabled={true} className={classes.button} onClick={() => {}}>
                      گزارش
                      <br />
                      صورتحساب
                    </Button>
                  )}
                  {(String(currentLoaction?.pathname).toUpperCase().includes('IMPREST')
                    ? actionsList['depositImprestIdAccountBtn']
                    : actionsList['depositIdAccountBtn']) && (
                    <Button
                      className={classes.button}
                      onClick={() => {
                        generateCreditInvoicePaymentNumber('PODLAND_WALLET', 'IRR');
                      }}
                    >
                      {loading ? (
                        'لطفا صبر کنید'
                      ) : (
                        <>
                          دریافت
                          <br />
                          شناسه واریز
                        </>
                      )}
                    </Button>
                  )}
                </div>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      ) : null}

      {data.length > 0
        ? data.map((item, k) => {
            const blockedAmount = getBlockedAmount(item?.wallet)?.amount ?? 0;
            return (
              <Grid key={item.id} container spacing={1} style={{ marginBottom: 8 }}>
                <Grid item xs={12} md={10} lg={6}>
                  <Grid container>
                    <Grid
                      item
                      xs={12}
                      className={clsx(classes.balanceBox, {
                        disabled: item?.block,
                      })}
                    >
                      {item?.block ? (
                        <Grid item className={classes.expiredFlag}>
                          حساب مسدود شده
                        </Grid>
                      ) : null}

                      <Typography className={classes.balanceTitle}>
                        موجودی حساب دیجیتال {item.walletName}
                      </Typography>

                      <Typography className={classes.balancePrice}>
                        <span className={classes.balanceAmount}>
                         <PriceLabel amount={item?.amount} />
                        </span>
                        <span className={classes.currencyText}>{currencyText}</span>
                      </Typography>

                      <Typography className={classes.balancePriceText}>
                         <NumberToPersianWords number={item.amount}  />
                      </Typography>

                      <Typography className={classes.blockedAmount} style={{ marginTop: 8 }}>
                        مبلغ مسدود شده : 
                         <b style={{margin:'0 4px'}}> <PriceLabel amount={ blockedAmount} currency={currencyText}/></b>
                      </Typography>

                      <Typography className={clsx(classes.blockedAmount, classes.enlighNum)}>
                        شماره کارت :
                        <pre className={classes.blockedAmountPre}>{item?.pan ?? '-'}</pre>
                      </Typography>

                      <Typography className={clsx(classes.blockedAmount, classes.enlighNum)}>
                        شماره شبا :
                        <b>{item?.sheba ?? '-'}</b>
                        {item?.sheba ? (
                          <IconButton
                            className={classes.copyIcon}
                            onClick={() => copyItem(item.sheba)}
                            size="large">
                            <Icons icon="copy" color="#d1d8dc" hover="#303d8f" size="18" />
                          </IconButton>
                        ) : null}
                      </Typography>

                      <div
                        role="group"
                        aria-label="outlined primary button group"
                        className={classes.buttonWrapper}
                      >
                        {(String(currentLoaction?.pathname).toUpperCase().includes('IMPREST')
                          ? actionsList['chargeImprestAccountBtn']
                          : actionsList['chargeAccountBtn']) && (
                          <Button
                            className={classes.button}
                            onClick={() => charge(item.wallet)}
                            disabled={disabledBtn}
                          >
                            شارژ
                          </Button>
                        )}
                        {(String(currentLoaction?.pathname).toUpperCase().includes('IMPREST')
                          ? actionsList['withdrawImprestAccountBtn']
                          : actionsList['withdrawAccountBtn']) && (
                          <ButtonLoading
                            loading={loadingCartable == item?.id}
                            disabled={disabledBtn}
                            name={
                              loadingCartable == item?.id ? (
                                ''
                              ) : (
                                <>
                                  برداشت
                                  <br />
                                  وجه
                                </>
                              )
                            }
                            className={classes.btnLoading}
                            onClick={() => onCheckIsCartable(item)}
                          />
                        )}
                        {(String(currentLoaction?.pathname).toUpperCase().includes('IMPREST')
                          ? actionsList['MoneyImprestTransferAccountBtn']
                          : actionsList['MoneyTransferAccountBtn']) && (
                          <Button
                            className={classes.button}
                            onClick={() => handleWallet(item.id, 'MoneyTransfer', item)}
                            disabled={disabledBtn}
                          >
                            انتقال
                            <br />
                            وجه
                          </Button>
                        )}
                        {/* {!String(currentLoaction?.pathname).toUpperCase().includes('IMPREST') &&
                          item.cardRequestSrv &&
                          actionsList['digitalCardService'] && (
                            <Button
                              className={classes.button}
                              onClick={() => handleWallet(item.id, 'IssueCards', item)}
                            >
                              خدمات کارت
                            </Button>
                          )} */}
                        {(String(currentLoaction?.pathname).toUpperCase().includes('IMPREST')
                          ? actionsList['reportImprestAccountBtn']
                          : actionsList['reportAccountBtn']) && (
                          <Button
                            className={classes.button}
                            onClick={() => handleWallet(item.id, 'Transactions', item)}
                            disabled={disabledBtn}
                          >
                            گزارش
                            <br />
                            صورتحساب
                          </Button>
                        )}
                        {(String(currentLoaction?.pathname).toUpperCase().includes('IMPREST')
                          ? actionsList['depositImprestIdAccountBtn']
                          : actionsList['depositIdAccountBtn']) && (
                          <Button
                            className={classes.button}
                            disabled={disabledBtn}
                            onClick={() => {
                              generateCreditInvoicePaymentNumber(
                                item.wallet,
                                item.currencySrv.code,
                              );
                            }}
                          >
                            {loading ? (
                              'لطفا صبر کنید'
                            ) : (
                              <>
                                دریافت
                                <br />
                                شناسه واریز
                              </>
                            )}
                          </Button>
                        )}
                        {(String(currentLoaction?.pathname).toUpperCase().includes('IMPREST')
                          ? actionsList['FinancialImprestLicensesAccountBtn']
                          : actionsList['FinancialLicensesAccountBtn']) && (
                          <Button
                            className={classes.button}
                            disabled={disabledBtn}
                            onClick={() => handleWallet(item.wallet, 'GrantPermission', item)}
                          >
                            مجوز های مالی
                            <br />
                            اعطا شده
                          </Button>
                        )}
                        {(String(currentLoaction?.pathname).toUpperCase().includes('IMPREST')
                          ? actionsList['FinancialImprestLicensesReciveAccountBtn']
                          : actionsList['FinancialLicensesReciveAccountBtn']) && (
                          <Button
                            className={classes.button}
                            disabled={disabledBtn}
                            onClick={() =>
                              handleWallet(item.wallet, 'GrantPermissionReceived', item)
                            }
                          >
                            مجوزهای مالی
                            <br />
                            دریافت شده
                          </Button>
                        )}
                      </div>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            );
          })
        : null}

      <SimpleDialog
        fullWidth
        maxWidth="sm"
        open={openDialog}
        title="دریافت شناسه واریز"
        onClose={() => setOpenDialog(false)}
      >
        <Paper className={classes.detailPaper}>
          <Typography className={classes.newTokenText}>{userBillNumber}</Typography>

          <Grid container>
            <Button
              onClick={() => copyItem(userBillNumber)}
              variant="outlined"
              style={{ margin: 'auto' }}
            >
              کپی کردن شناسه واریز
            </Button>
          </Grid>
        </Paper>
      </SimpleDialog>
    </>
  );
};

export default Wallet;
